export const colors = {
	primary: {
		light: '#52ae32',
		dark: '#3cb49f',
	},
	text: {
		light: '#000000',
		dark: '#ffffff',
	},
	border: {
		light: '#d1d5db',
		dark: '#4b5563',
	},
	disabled: {
		light: 'rgba(0, 0, 0, 0.7)',
		dark: 'rgba(255, 255, 255, 0.7)',
	},
	switch: {
		track: {
			light: '#e3e3e3',
			dark: '#39393D',
		},
	},
	accordion: {
		background: {
			light: '#ffffff', // Matches surface.light from tailwind.config.js
			dark: '#144448', // Matches surface.dark from tailwind.config.js
		},
		header: {
			light: '#e0e0e0', // Updated to a slightly darker shade for better contrast
			dark: '#062f33', // Updated to a slightly lighter shade for better contrast
		},
		text: {
			light: '#202020', // Matches text.dark from tailwind.config.js
			dark: '#ffffff', // Matches text.light from tailwind.config.js
		},
		border: {
			light: '#e5e7eb', // Matches a light border color
			dark: '#0d2d30', // Matches background.200.dark from tailwind.config.js
		},
	},
}

export const breakpoints = {
	xs: 0,
	sm: 640,
	md: 768,
	lg: 1024,
	xl: 1280,
}
